window.addEventListener('message', function messageHandler(e) {
  if (e.data === 'aoflReady') {
    require('./download-app-page/download-app-page.html');
    window.removeEventListener('message', messageHandler);
  }
});



// WEBPACK FOOTER //
// ./download_app/es-US/js/main.js